module.exports = __webpack_public_path__ + "img/pagamento.a28e54b3.svg";